export default __webpack_public_path__ + "static/media/green-hospital.e3dc89ec.svg";